












































































































































































































































































































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { orderReturnDetail, orderRefund, rejectRefund,agreeReturn,
  rejectReturn, } from "@/api/order";

@Component({
  components: {},
})
export default class OrderDetail extends Mixins(loading) {
  afterDetail: any = {
    omsOrderItem: {},
  };
  subOrderId: any = "";

  mounted() {
    let route: any = this.$route;
    let { orderId } = route.query;
    if (!orderId) {
      this.$message.error("订单号不能为空");
      return;
    }
    this.subOrderId = orderId;
    this.showLoading();
    this.getData();
  }

  getData() {
    orderReturnDetail({
      subOrderId: this.subOrderId,
    }).then((res: any) => {
      this.afterDetail = res.data;
      this.hideLoading();
    });
  }

  viewVipInfo() {
    let id = this.afterDetail.memberId;
    this.$router.push({
      path: "/vipInfo",
      query: { id: id },
    });
  }

  viewReturnDetail() {
    let orderId = this.subOrderId;
    this.$router.push({
      path: "/returnDetail",
      query: { orderId: orderId },
    });
  }

   viewOrderDetail() {
    let {id} = this.afterDetail;
    this.$router.push({
      path: "/orderDetail",
      query: { orderId: id },
    });
  }

  // 发起退款
  orderRefundfun() {
    let { omsOrderItem } = this.afterDetail;
    this.$confirm("是否确认退款?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      orderRefund({
        orderId: omsOrderItem.orderId,
        subOrderIds: omsOrderItem.id,
      }).then((res: any) => {
        this.$message.success("退款成功");
        this.getData();
      });
    });
  }
  // 取消退款
  rejectRefundfun() {
    let { omsOrderItem } = this.afterDetail;
    this.$confirm("是否拒绝退款?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      rejectRefund({
        orderId: omsOrderItem.orderId,
        subOrderIds: omsOrderItem.id,
      }).then((res: any) => {
        this.$message.success("拒绝成功");
        this.getData();
      });
    });
  }

  // 同意申请
  agreeReturn_() {
    let { omsOrderItem } = this.afterDetail;
    this.$confirm("是否同意申请?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      agreeReturn({
        orderId: omsOrderItem.orderId,
        subOrderIds: omsOrderItem.id,
      }).then((res: any) => {
        this.$message.success("已同意申请");
        this.getData();
      });
    });
  }
  // 拒绝申请
  rejectReturn_() {
    let { omsOrderItem } = this.afterDetail;
    this.$confirm("是否拒绝申请?", "提示", {
      confirmButtonText: "是的",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      rejectReturn({
        orderId: omsOrderItem.orderId,
        subOrderIds: omsOrderItem.id,
      }).then((res: any) => {
        this.$message.success("已拒绝申请");
        this.getData();
      });
    });
  }

}
